import { initializeApp } from 'firebase/app';
import { getAuth, browserLocalPersistence, setPersistence } from 'firebase/auth';
import { firebaseConfigForMode, resolveFirebaseMode } from './firebaseProjects';

// Same Firebase project as the rest of the Sales Guru platform — auth is shared.
// WHICH PROJECT THIS BUILD AUTHENTICATES AGAINST — see firebaseProjects.ts.
// The literal that used to sit here named `salesguru-86316` unconditionally,
// which is why dev accounts and paying customers' users shared one identity
// pool: there was no mechanism to vary it, in a codebase that already varies a
// dozen other values per tenant at build time.
const firebaseMode = resolveFirebaseMode(process.env.REACT_APP_FIREBASE_MODE);
const firebaseConfig = firebaseConfigForMode(firebaseMode);

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);

setPersistence(auth, browserLocalPersistence).catch((error) => {
  // Non-fatal: auth still works, just won't persist across reloads.
  console.error('[Firebase] Failed to set auth persistence:', error);
});

export default app;
